import { GridContent } from 'shared/components/ProductGrid/GridContent'
import ProductGrid from 'shared/components/ProductGrid/ProductGrid'
import useCurrency from 'shared/hooks/useCurrency'

export interface ConsumerSearchHit {
  id: string
  name: string
  url: string
  slug: string
  pictureUrl: string
  retailPrice?: {
    localizedValue: string | null
  }
  price?: {
    localizedValue: string | null
  }
  brandName: string
}

const consumerSearchMapHitsToProducts = (hits: ConsumerSearchHit[]) => {
  return hits.map((hit) => {
    const { id, name, slug, pictureUrl, brandName, retailPrice, price } = hit
    return {
      id,
      name,
      slug,
      pictureUrl,
      retailPrice: {
        localizedValue: retailPrice?.localizedValue * 100,
      },
      price: {
        localizedValue: price?.localizedValue * 100,
      },
      brandName,
    }
  })
}

type ProductHitsProps = {
  hidePrices?: boolean
  hits: ConsumerSearchHit[]
}

export const Hits = ({ hits, hidePrices }: ProductHitsProps) => {
  const { loading, error } = useCurrency()
  if (loading || error) {
    return null
  }

  const products = consumerSearchMapHitsToProducts(hits)

  return (
    <GridContent>
      <ProductGrid products={products} hidePrices={hidePrices} />
    </GridContent>
  )
}
